import { Component, ElementRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CommonService } from './core/services/common.service';
import { InactivityTimerService } from './core/services/inactivity-timer.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './core/services/auth.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: false
})
export class AppComponent {
  title = 'clientapp';
  
  public Editor = ClassicEditor;
  isGenerateToken: boolean = false;
  profileData:any = '';

  constructor(
    private router: Router,
    private commonService:CommonService,
    private inactivityTimerService: InactivityTimerService,
    private toaster:ToastrService,
    private authService:AuthService,
    private el: ElementRef
  ){
    if (environment.newChatboat) { //chatboat newest
      this.loadUvaWidget();
    }

    this.el.nativeElement.removeAttribute('ng-version');// remove ng version attribute from the root element
    let data:any = localStorage.getItem('profileStatus')
    if(data){
      this.profileData = JSON.parse(data)
    }
    this.findroute();
  }

  ngOnInit() {
    // New chatboat
    window.addEventListener("message", (event: any) => {
      if (event.data?.type === "OPEN_SCHEME") {
        const url = decodeURIComponent(event.data.url);
        const parsed = new URL(url);
        const schemeId = parsed.searchParams.get("SchemeId");
        if (schemeId) {
          sessionStorage.setItem('schemeID', JSON.stringify(schemeId))
          this.router.navigate(['/scheme/view-scheme']);
        }
      }
    });

    this.inactivityTimerService.userLoggedOut$.subscribe((loggedOut) => {
      if (loggedOut) {
        this.commonService.setRefreshHeaderMenu({logout:true})
        this.toaster.info('User has been logged out due to inactivity.');
      }
    });
  }

  private loadUvaWidget(): void {
    (window as any).chat_context = { language: 'eng_Latn' };
    (window as any).iky_base_url = environment.iky_base_url;
    (window as any).iky_chatbot_url = environment.iky_chatbot_url;
    (window as any).iky_api_key = environment.iky_api_key;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = environment.iky_src;
    script.async = true;

    document.head.appendChild(script);
  }

  customeScroll(){
    this.commonService.customescroll();
  }

  findroute(){
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
            if (event.url.includes('redirect-ubp')) {
              this.isGenerateToken = true;
            }
            if (event.url.includes('ubp-e-sign')) {
              this.isGenerateToken = true;
            }
      }
    });

   


if (!this.isGenerateToken && this.profileData?.userType != 1) {

  const token = localStorage.getItem('access_token');
  const profileData = sessionStorage.getItem('profileData');
  const adminUser = localStorage.getItem('admin');
  const menuId = sessionStorage.getItem('menuId');
  const moduleId = sessionStorage.getItem('moduleId');
  const role = this.authService.getUserRole();
  let adminRoles = [2, 10, 14, 15, 16, 17, 19, 20];

  if (!token) {
    return;
  }

  if (adminUser !== 'A') {

    switch (role) {
      case 1:
        // this.router.navigate(['/scheme/udyam-dashboard/dashboard']); // in case of login udyam user may go to any open page
        break;

      case 9:
        this.router.navigate(['/scheme/dept-dashboard/ramp-national']);
        break;
      case 12:
        this.router.navigate(['/scheme/dept-dashboard/ramp-state']);
        break;
      case 13:
        this.router.navigate(['/scheme/dept-dashboard/anti-fc-report']);
        break;

      default:
        this.router.navigate(['/scheme/non-msme-dashboard/dashboard']);
        break;
    }

  } else if (!menuId && !moduleId && adminRoles.includes(role)) {

    this.router.navigate(['/dashboard']);
  }
}
  }
}
